import React from "react";
import styled from "styled-components/native";
import { VDBText } from "../..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import { SelectedItemTheme } from "@components/atoms/Button/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";
import { View } from "react-native";
import { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";

type ValueFilterProps = {
  value: string;
  children?: any;
  isSelected: boolean;
  style?: any;
  selectedStyle: SelectedItemTheme;
  customTheme?: boolean;
  isPlaceholder?: boolean;
  isHovered: boolean;
  applyMinWidth?: boolean;
};

const ValueFilterText = ({
  value,
  isSelected,
  style,
  selectedStyle,
  isHovered,
  applyMinWidth,
}: ValueFilterProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { user } = useUserInfo();
  const { t } = useTranslation();
  return (
    <View style={style}>
      <CustomView
        isSelected={isSelected}
        isPlaceholder={!value}
        selectedStyle={selectedStyle}
        customTheme={!!user?.custom_theme}
        theme={theme}
        isHovered={isHovered}
        applyMinWidth={applyMinWidth}
      >
        {
          <VDBText
            numberOfLines={1}
            textAlign="center"
            color={
              isSelected
                ? user?.custom_theme
                  ? theme["option-cont-active"]
                  : theme["core-05"]
                : theme["option-cont"]
            }
            type={typography["Body-M"]}
          >
            {t(`${value}`)}
          </VDBText>
        }
      </CustomView>
    </View>
  );
};

const CustomView = styled.View<ValueFilterProps>`
  align-items: center;
  justify-content: center;
  background: ${({ theme }: { theme: DefaultTheme }) =>
    theme["option-bg-static"]};
  border-radius: ${SpaceType.Basic}px;
  overflow: hidden;
  ${({ applyMinWidth }) =>
    applyMinWidth
      ? css`
          padding: ${SpaceType.Basic}px ${SpaceType.Extra}px;
        `
      : css`
          padding: ${SpaceType.Basic}px ${SpaceType.Tiny}px;
        `}
  background-color: ${({
    isSelected,
    theme,
    selectedStyle,
    isPlaceholder,
    isHovered,
  }) =>
    isPlaceholder
      ? "transparent"
      : isSelected
      ? theme[
          selectedStyle.primary
            ? (selectedStyle.primary as keyof DefaultTheme)
            : "diam-03"
        ]
      : isHovered
      ? theme["option-bg-hover"]
      : theme["option-bg-static"]};
  border-width: ${({ isPlaceholder }) => (isPlaceholder ? 0 : 1)}px;
  border-color: ${({ isSelected, theme, selectedStyle, customTheme }) =>
    isSelected
      ? customTheme
        ? theme[selectedStyle.primary as keyof DefaultTheme]
        : theme[
            selectedStyle.secondary
              ? (selectedStyle.secondary as keyof DefaultTheme)
              : "diam-04"
          ]
      : theme["option-bg-static"]};
`;

export default ValueFilterText;
